import { render, staticRenderFns } from "./OrgManage.vue?vue&type=template&id=f58cea52"
import script from "./OrgManage.vue?vue&type=script&lang=js"
export * from "./OrgManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports